import { UserRow, UserSortKey } from './saveUser.models';

export function compareUsers(a: UserRow, b: UserRow, key: UserSortKey): number {
  switch (key) {
    case 'name': {
      const first = String(a.strFullName ?? '').toUpperCase();
      const second = String(b.strFullName ?? '').toUpperCase();
      return first < second ? -1 : first > second ? 1 : 0;
    }
    case 'input':
      return parseFloat(String(b.iInput)) - parseFloat(String(a.iInput));
    case 'date':
      return new Date(b.strEsterakEndDate).valueOf() - new Date(a.strEsterakEndDate).valueOf();
    case 'lastLogin':
      return new Date(b.strLastLoginDateTime).valueOf() - new Date(a.strLastLoginDateTime).valueOf();
  }
}

// Preserve the existing priority: use the first field with matches, not an OR across fields.
export function filterFirstMatchingField<T>(rows: T[], fields: (keyof T)[], query: string): T[] {
  for (const field of fields) {
    const matches = rows.filter(row => String(row[field] ?? '').includes(query));
    if (matches.length) return matches;
  }
  return [];
}
